'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ellipsis = function (_Component) {
  (0, _inherits3.default)(Ellipsis, _Component);

  function Ellipsis(props) {
    (0, _classCallCheck3.default)(this, Ellipsis);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Ellipsis.__proto__ || (0, _getPrototypeOf2.default)(Ellipsis)).call(this, props));

    _this.state = {
      overflow: false,
      showAll: false
    };
    return _this;
  }

  // checking element height is only available after the component is rendered
  /* eslint react/no-did-mount-set-state: "off" */


  (0, _createClass3.default)(Ellipsis, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // XXX: This is a workaround for IE because IE calculates clientHeight and scrollHeight
      //      differently. The CSS line-height is 25. 10 is the margin to tolerate IE's calculation.
      this.setState({ overflow: this.textContainer.clientHeight + 10 < this.textContainer.scrollHeight });
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      e.preventDefault();
      this.setState({ showAll: !this.state.showAll });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          i18n = _props.i18n,
          children = _props.children;
      var _state = this.state,
          overflow = _state.overflow,
          showAll = _state.showAll;


      return _react2.default.createElement(
        'div',
        { className: 'fluid-description toggle-' + (showAll ? 'opened' : 'closed') },
        _react2.default.createElement(
          'p',
          { className: 'more-less-content', ref: function ref(elem) {
              _this2.textContainer = elem;
            } },
          children
        ),
        _react2.default.createElement(
          'div',
          { className: 'more-less' },
          overflow && _react2.default.createElement(
            'a',
            { href: true, className: 'toggle-icon-box', onClick: function onClick(e) {
                return _this2.toggle(e);
              } },
            _react2.default.createElement(
              'span',
              { className: 'toggle-title' },
              showAll ? i18n.ellipsis.showLess : i18n.ellipsis.showMore
            ),
            _react2.default.createElement('span', { className: 'toggle' })
          )
        )
      );
    }
  }]);
  return Ellipsis;
}(_react.Component); // Ellipsis

Ellipsis.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  children: _react.PropTypes.string.isRequired
};

exports.default = Ellipsis;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Ellipsis.js
// module id = 1198
// module chunks = 0